import { UnknownAction } from "@reduxjs/toolkit";
import {
  AUTHENTICATING_LINKEDIN_ACCOUNT,
  AUTHENTICATING_LINKEDIN_ACCOUNT_FAILED,
  AUTHENTICATING_LINKEDIN_ACCOUNT_SUCCEEDED,
  FETCH_LINKEDIN_INTEGRATION,
  FETCHING_LINKEDIN_INTEGRATION_FAILED,
  FETCHING_LINKEDIN_INTEGRATION_SUCCEEDED,
  DEACTIVATE_LINKEDIN_ACCOUNT,
  DEACTIVATING_LINKEDIN_ACCOUNT_FAILED,
  DEACTIVATING_LINKEDIN_ACCOUNT_SUCCEEDED,
  INVALIDATE_LINKEDIN_INTEGRATION,
  SHARE_LINKEDIN_POST_REQUEST,
  SHARING_LINKEDIN_POST_SUCCEEDED,
  SHARING_LINKEDIN_POST_FAILED,
  INVALIDATE_LINKEDIN_POST,
  FETCH_LINKEDIN_ORGANIZATION,
  FETCHING_LINKEDIN_ORGANIZATION_SUCCEEDED,
  FETCHING_LINKEDIN_ORGANIZATION_FAILED,
  FETCH_LINKEDIN_POST,
  FETCHING_LINKEDIN_POST_SUCCEEDED,
  FETCHING_LINKEDIN_POST_FAILED,
  INVALIDATE_LINKEDIN_POSTS,
  DELETE_LINKEDIN_SCHEDULED_POST,
  DELETING_LINKEDIN_SCHEDULED_POST_SUCCEEDED,
  DELETING_LINKEDIN_SCHEDULED_POST_FAILED
} from 'src/redux/actions/actionTypes';
import _ from "lodash";


export interface IOrganisation{
  id: string;
  name: string;
  profile: string;
}

interface IInitialState {

  authentication: {
    loading: boolean;
    error: any;
    succeeded: boolean;
  },
  deactivation: {
    loading: boolean;
    error: any;
    succeeded: boolean;
  },
  post:{
    posting: boolean;
    error: any;
    succeeded: boolean;
  },
  organisation: {
    loading: boolean;
    error: any;
    succeeded: boolean;
    records: IOrganisation[];
  };
  item: any;
  loading: boolean;
  error: any;
  succeeded: boolean;
  deleting?: boolean;
  posts: {
    items: any[];
    pagination: {
      currentPage: number;
      totalPages: number;
    }
  };
}
const initialState: IInitialState = {
  authentication: {
    loading: false,
    error: null,
    succeeded: false
  },
  deactivation: {
    loading: false,
    error: null,
    succeeded: false
  },
  post:{
    posting: false,
    error: null,
    succeeded: false
  },
  organisation: {
    loading: false,
    error: null,
    succeeded: false,
    records: []
  },
  item: null,
  loading: false,
  deleting: false,
  error: null,
  succeeded: false,
  posts: {
    items: [],
    pagination: {
      currentPage: 0,
      totalPages: 0
    }
  }
}


export function linkedInReducer(state: IInitialState = initialState, action: UnknownAction): IInitialState {
  switch (action.type) {
    case AUTHENTICATING_LINKEDIN_ACCOUNT: {
      return {
        ...state,
        authentication: {
          ...state.authentication,
          loading: true
        }
      }
    }
    case AUTHENTICATING_LINKEDIN_ACCOUNT_SUCCEEDED: {
      return {
        ...state,
        authentication: {
          ...state.authentication,
          loading: false,
          succeeded: true
        },
        item: action.payload
      }
    }

    case AUTHENTICATING_LINKEDIN_ACCOUNT_FAILED: {  
      return {
        ...state,
        authentication: {
          ...state.authentication,
          loading: false,
          error: action.payload
        }
      }
    }

    case FETCH_LINKEDIN_INTEGRATION: {
      return {
        ...state,
        loading: true,
        succeeded: false,
        error: null
      }
    }

    case FETCHING_LINKEDIN_INTEGRATION_SUCCEEDED: {
      return {
        ...state,
        loading: false,
        succeeded: true,
        item: action.payload,
        error: null
      }
    }

    case FETCHING_LINKEDIN_INTEGRATION_FAILED: {
      return {
        ...state,
        loading: false,
        succeeded: false,
        error: action.payload
      }
    }

    case DEACTIVATE_LINKEDIN_ACCOUNT: {
      return {
        ...state,
        deactivation: {
          ...state.deactivation,
          loading: true
        }
      }
    }

    case DEACTIVATING_LINKEDIN_ACCOUNT_SUCCEEDED: {
      return {
        ...initialState,
        deactivation: {
          error: null,
          loading: false,
          succeeded: true
        },
      }
    }

    case DEACTIVATING_LINKEDIN_ACCOUNT_FAILED: {
      return {
        ...state,
        deactivation: {
          ...state.deactivation,
          loading: false,
          error: action.payload
        }
      }
    }

    case INVALIDATE_LINKEDIN_INTEGRATION: {
      return initialState;
    }

    case SHARE_LINKEDIN_POST_REQUEST:{
      return {
        ...state,
        post: {
          ...state.post,
          posting: true
        }
      }
    }


    case SHARING_LINKEDIN_POST_FAILED:{
      return {
        ...state,
        post: {
          ...state.post,
          posting: false,
          error: action.payload
        }
      }
    }

    case INVALIDATE_LINKEDIN_POST:{
      return {
        ...state,
        post: {
          posting: false,
          error: null,
          succeeded: false
        }
      }
    }

      case SHARING_LINKEDIN_POST_SUCCEEDED:{
      return {
        ...state,
        post: {
          ...state.post,
          posting: false,
          succeeded: true
        }
      }
    }

  case FETCH_LINKEDIN_ORGANIZATION: {
  return {
    ...state,
        organisation: {
          ...state.organisation,
          loading: true,
          succeeded: false,
          error: null
        }
      };
    }

  case FETCHING_LINKEDIN_ORGANIZATION_SUCCEEDED: {
  return {
    ...state,
    organisation: {
      ...state.organisation,
      loading: false,
      succeeded: true,
      records: action.payload as IOrganisation[],  
    },
   };
   }


  case FETCHING_LINKEDIN_ORGANIZATION_FAILED: {
  return {
    ...state,
    loading: false,
    succeeded: false,
    error: action.payload
  };
}

  case FETCH_LINKEDIN_POST: {
    return {
      ...state,
      loading: true,
      succeeded: false,
      error: null
    };
  }

  case FETCHING_LINKEDIN_POST_SUCCEEDED: {
    const existingPosts = _.get(state, "posts.items", []);
    const response = action.payload as any;
    const newPosts = _.uniqBy(response.records, 'id');

    const allPosts = _.uniqBy([...existingPosts, ...newPosts], 'id');

    return {
      ...state,
      loading: false,
      succeeded: true,
      posts: {
        items: allPosts,
        pagination: {
          currentPage: response.currentPage,
          totalPages: response.totalPages
        }
      }
    };
  }

  case FETCHING_LINKEDIN_POST_FAILED: {
    return {
      ...state,
      loading: false,
      succeeded: false,
      error: action.payload
    };
  }

  case INVALIDATE_LINKEDIN_POSTS: {

    return {
      ...state,
      posts: {
        items: [],
        pagination: {
          currentPage: 0,
          totalPages: 0
        }
      }
    };
  }

  case DELETE_LINKEDIN_SCHEDULED_POST: {
    return {
      ...state,
      deleting: true,
      succeeded: false,
      error: null
    };
  }

  case DELETING_LINKEDIN_SCHEDULED_POST_SUCCEEDED: {

    const response = action.payload as any;

    const postId = response.postId;
    const existingPosts = _.get(state, "posts.items", []);
    const updatedPosts = existingPosts.filter(post => post.id !== postId);

    return {
      ...state,
      deleting: false,
      posts: {
        ...state.posts,
        items: updatedPosts
      }
    };
  }

  case DELETING_LINKEDIN_SCHEDULED_POST_FAILED: {
    return {
      ...state,
      deleting: false,
      error: action.payload
    };
  }


    default: {
      return state;
    }
  }
}